import { VApp } from 'vuetify/lib/components/VApp';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    VApp,
    [
      _vm._l(_vm.partners, function (partner) {
        return _c(_setup.PartnerAnalysesCard, {
          key: partner.id,
          attrs: {
            partner: partner,
            "use-banner": partner.discount > 0,
            "data-qa": "partner_card",
          },
        })
      }),
      _vm._v(" "),
      _c(_setup.LaboratoriesList, {
        on: { "click:lab": _setup.handleClickLab },
      }),
      _vm._v(" "),
      _c("div", { attrs: { id: "use-vue-base-dialog" } }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }